// extracted by mini-css-extract-plugin
export default {"pageWrap":"ac-z","fullWidth":"bc-z","heading":"cc-z","fullBleed":"dc-z","hidden":"ec-z"};